import shirt from "../assets/image 5.png";
import profile from "../assets/Ellipse 7.png";
import flag from "../assets/France.png";

import "../Components/CSS/pagesCSS/horse.css";
import ListGroup from 'react-bootstrap/ListGroup';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { BsFillCaretRightFill } from 'react-icons/bs';
import '../Components/CSS/pagesCSS/owner.css'
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import Moment from "react-moment";
import Defaultimg from "../assets/Frame.png"
import { useTranslation } from "react-i18next";

import { getBaseUrl } from "../service/apiUrl";
const OwnerDetail = (data) => {
  const { t } = useTranslation()
  const cookiedata = Cookies.get('i18next');
  const token = Cookies.get("token");

  const navigate = useNavigate();
  const btnNew1 = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "13px 10px",
    gap: "10px",
    width: "112px",
    height: "24px",
    background: "#FF0000",
    borderRadius: "10px",
    border: "none",
    color: "#fff",
    margin: '6px'
  };

  const handleTrack = async (Id) => {
    try {
      const res = await axios.post(
        `${getBaseUrl()}/trackowner`, { Owner: Id }, {
          headers: { Authorization: token, "x-xsrf-token": token },
        },
      );
      toast('Tracked Success')
      navigate('/tracker')
    } catch (error) {
      const err = error.response.data.message;
      toast(err)
    }
    
  };
  return (
    <>
      <div className="aboutpage">
        <div className="RaceDetailCard">
          <div className="horseheader1">
            <div className="horseshirt">
              <img src={data.data.image ? data.data.image : Defaultimg} alt="" className="horseshirtimage" style={{
                height: '90px'
              }} />

            </div>

            <div className="horsecenterdata">
              <span
                style={{
                  display: "flex",
                }}
              >
                <p
                  style={{
                    fontWeight: "700",
                    fontSize: " 19.6px",
                    lineHeight: "24px",
                    color: "#19469D",
                  }}
                >
                  {cookiedata === "en" ? (data.data.NameEn ? data.data.NameEn : <>- </>) : (data.data.NameAr ? data.data.NameAr : <>- </>)}
                </p>
                {/* <p
                  style={{
                    fontSize: "12px",
                    marginLeft: '20px'
                  }}
                >
                  {data.data.DOB === null ? <>No Data</> : <><Moment fromNow ago>
                    {data.data.DOB}
                  </Moment></>}

                </p> */}
              </span>
              <span
                style={{
                  display: "flex",
                }}
              >
                <p
                  style={{
                    fontSize: "12px",
                    paddingLeft: "10px"
                  }}
                > {t("Title")}
                  <b style={{
                    paddingLeft: "5px"
                  }}>       {cookiedata === "en" ? (data.data.TitleEn ? data.data.TitleEn : <>- </>) : (data.data.TitleAr ? data.data.TitleAr : <>- </>)}
                  </b>
                </p>
                <p
                  style={{
                    fontSize: "10px",
                    paddingLeft: "6px"
                  }}
                >{t("Regd")}
                  <b style={{
                    paddingLeft: "5px"
                  }}> {data.data.RegistrationDate === null ? <>No Data</> : <><Moment fromNow ago>
                    {data.data.RegistrationDate}
                  </Moment></>}</b>
                </p>

              </span>
              <div className="horsedetailimage">
                {
                  data.data.OwnerDataNationalityData ? <>
                    <img src={data.data.OwnerDataNationalityData.image ? data.data.OwnerDataNationalityData.image : Defaultimg} alt="" />

                  </> : <>- </>
                }
                <span>
                  <p
                    style={{
                      fontSize: "12px",
                      lineHeight: "10px",
                      marginLeft: "10px",
                    }}
                  >
                    <b style={{
                      padding: "10px",

                    }}>{t("Nationality")}</b>{cookiedata === "en" ? (data.data.OwnerDataNationalityData.NameEn ? data.data.OwnerDataNationalityData.NameEn : <>- </>) : (data.data.OwnerDataNationalityData.NameAr ? data.data.OwnerDataNationalityData.NameAr : <>- </>)}
                  </p>
                  <p
                    style={{
                      fontSize: "12px",
                      marginLeft: "10px",
                    }}
                  >
                    <b style={{
                      padding: "10px",
                    }}>{t("Short Name")} </b>{cookiedata === "en" ? (data.data.ShortEn ? data.data.ShortEn : <>- </>) : (data.data.ShortAr ? data.data.ShortAr : <>- </>)}
                  </p>
                </span>

              </div>
            </div>
            {/* <div className="horseimage">
        <img src={data.data.HorseImage} alt='' />
      </div> */}
            <div className="ownerTrack">

              <button
                style={btnNew1}
                onClick={() => handleTrack(data.data._id)}
              >
                {t("Track")}
              </button>
            </div>
          </div>
          <div className="horsebody">
            <ListGroup>
              <ListGroup.Item className="horsebodyitem">
                <p style={{
                  color: '#fff',
                  textAlign: 'center'
                }}>{t("National Hunt Form")}</p>
              </ListGroup.Item>
              <div className="horsehistorylist">
                <p style={{
                  color: '#fff',
                  padding: '10px'
                }}>
                  00 / P8PP44 / 7P3214112 / 1211
                </p>
              </div>
              <ListGroup.Item className="horsebodyitem">
                <div className='horserecord'>
                  <p>{t("Lifetime Record")}</p>
                  <p>{t("Runs")}</p>
                  <p>{t("Wins")}</p>
                  <p>{t("2nd")}</p>
                  <p>{t("3rd")}</p>
                  <p>{t("Winnings")}</p>
                  <p>{t("Earnings")}</p>
                  <p>{t("OR")} </p>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="horsebodyitem1">
                <div className='horserecord'>
                  <h6>{t("FLAT TURF")}</h6>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="horsebodyitem1">
                <div className='horserecord'>
                  <h6>{t("RULES RACES")}</h6>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="horsebodyitem1">
                <div className='horserecord'>
                  <h6>{t("DURT")}</h6>
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="horsebodyitem1">
                <div className='horserecord'>
                  <h6>{t("TOTAL")}</h6>
                </div>
              </ListGroup.Item>
            </ListGroup>
          </div>
          <div className="RaceNav HorseNav">
            <Tabs id="uncontrolled-tab-example" className="mb-3 RaceNavItem">
              <Tab eventKey="Form" title={t("Form")} tabClassName="profile-tabitem">
                <div className="RaceDetailCard">
                <div className="BodyNew">
                                <table className="customers">
                                  <thead className="customers5">
                                    <tr>
                                      <th>{t("Date")}</th>
                                      <th>{t("Cr")}</th>
                                      <th>{t("Dist")}</th>
                                      <th>{t("TC")}</th>
                                      {/* <th>{t("Type")}</th> */}
                                      <th>{t("Dts")}</th>
                                      <th>{t("time")}</th>
                                      <th>{t("Wgt")}</th>
                                      <th>{t("FP")}</th>
                                      <th>{t("Les")}</th>
                                      <th>{t("RS")}</th>
                                      <th>{t("BtBy")}</th>
                                      <th>{t("Kgs")}</th>
                                      <th>{t("Draw")}</th>
                                      <th>{t("OR")}</th>
                                      <th></th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody className="customers1">
                                    
                                  </tbody>
                                </table>
                              </div>
                </div>
              </Tab>
              <Tab
                eventKey="Entries"
                title={t("Entries")}
                tabClassName="profile-tabitem"
              >
                <div className="RaceDetailCard">retre</div>
              </Tab>
              <Tab eventKey="Stats" title={t("Stats")} tabClassName="profile-tabitem">
                <div className="RaceDetailCard">retr</div>
              </Tab>

            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};
export default OwnerDetail;
